(function() {
    'use strict';
    angular.module('wbDashboard').directive('wbTabNav', ['$timeout', '$location', function ($timeout, $location) {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                tabs: '=',
            },
            templateUrl: 'app/themes/aurea/directives/tab-nav/tabNav.tpl.html',
            link: function (scope, element) {

                var callbacks = {
                    "beforeEnter": false,
                    "afterEnter": false,
                };
                var halted = false;

                scope.$watchCollection("tabs.data", function(data) {
                    initData(data);
                });

                scope.$watch("tabs.active",function(active, prev) {
                    if (active && !halted) {
                        if (scope.preLoadTab(active) || !scope.tabs.previous) {
                            scope.tabs.previous = prev;
                            scope.loadTab(active);
                        } else {
                            scope.tabs.active = prev;
                            halted = true;
                        }
                    } else {
                        halted = false;
                    }
                });

                scope.switchTab = function(newTab) {
                    scope.tabs.active = newTab;
                };

                scope.preLoadTab = function(active) {
                    if (scope.tabs.data[active].callbacks.beforeEnter) {
                        if (scope.tabs.data[active].callbacks.beforeEnter(scope.tabs.previous, scope.tabs.active) === false) {
                            return false;
                        }
                    }
                    return true;
                };
                scope.loadTab = function(active) {
                    if (active !== scope.tabs.previous) {
                        //don't change hash if it's initial tab
                        //can cause extra transition on page
                        $location.hash(active).replace();
                    }
                    if (scope.tabs.data[active].callbacks.afterEnter) {
                        $timeout(function() {
                            scope.tabs.data[active].callbacks.afterEnter(scope.tabs.previous, scope.tabs.active);
                        });
                    }
                    $timeout(function() {
                        angular.element( "*:focus" ).blur();
                        if (scope.tabs.scrollTop) {
                            $("html, body").animate({ scrollTop: scope.tabs.scrollTop }, 200);
                        }
                    });
                };

                function initData(data) {
                    angular.forEach(scope.tabs.data, function(tab, key) {
                        /*jshint -W030 */
                        tab.callbacks || (tab.callbacks = {});
                        /*jshint +W030 */
                        tab.callbacks = angular.extend({}, callbacks, tab.callbacks);
                    });
                    if (!scope.tabs.init) {
                        var hashTab = $location.hash();
                        if (hashTab in scope.tabs.data) {
                            scope.switchTab(hashTab);
                        }
                    }
                    scope.tabs.init = true;
                }
            }
        };
    }]);
})();
